<template>
  <div class="mapDistance">
    <div class="topButton mr20" @click.stop="beginDistance">测距离</div>
    <div class="topButton" @click="beginArea">测面积</div>
    <div class="resultTitle">测量结果</div>
    <div class="resultItem" v-for="(item, index) in clResult">{{ item }}</div>
  </div>
</template>

<script>
export default {
  props: {
    clResult: [],
  },
  methods: {
    beginDistance() {
      this.$emit("beginDistance");
    },
    beginArea() {
      this.$emit("beginArea");
    },
  },
};
</script>

<style lang="scss" scoped>
.mapDistance {
  .topButton {
    background-color: rgba(64, 158, 255, 1);
    width: 80px;
    height: 30px;
    border-radius: 15px;
    color: white;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border: 1px solid white;
    cursor: pointer;
  }
  .mr20 {
    margin-right: 20px;
  }
  .resultTitle {
    height: 20px;
    line-height: 20px;
    margin: 20px 0;
    font-weight: 600;
    font-size: 20px;
  }
}
</style>
